import React from 'react';
import LogoSVG from '../assets/images/svg/logo.svg'

export const Logo: React.FC = () => <div className="Logo"><LogoSVG /></div>